<template lang="jade">
  .container-fluid
    .row
      .profile_main.col-md-12
        header.profile_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-10.col-xs-12.clearfix preset
        section.profile_content.col-lg-12.col-md-12.col-sm-12.col-xs-12.row_space--xs
          .profile_header.clearfix
            h2.title_bar.clearfix  preset profile
          .col-xs-12.col-sm-11.col-md-10.col-lg-9.col-centered
            .table-responsive
              table.profile_table.col-centered.table.table-bordered.table-hover.table-striped
                tr
                  th No.
                  th Name
                  th.hidden-xs.output_name_header(v-for="(key,card) in outputCards") {{key}}
                    br
                    | {{card.name}}
                  th.function
                tr.profile__row(v-for="(key,profile) in profiles")
                  td {{key}}
                  td {{profile.name}}
                  td.hidden-xs(v-for="(output, input) in profile.mapping" v-show="inputCards[output].name !== 'all' ")
                    span.name(v-if="input !== '0'") {{inputCards[input].name}}
                    span.name(v-else)
                      i.fa.fa-times.fa-2x
                    span.port(v-show="input !== '0' && inputCards[input]") ({{input}})
                  td.edit(data-index= "{{$index}}")
                    span(v-on:click.stop="toSwitchModal(key)")
                      i.fa.fa-edit
  modal(
    v-bind:show.sync="showModal"
    effect= "fade"
    v-bind:callback='applyChange'
    v-bind:close='cancel'
    ok-text="Apply"
    cancel-text="Cancel"
    v-bind:backdrop= 'false'
    title="Configuration"
    ).popout.col-md-12
    .modal-body(slot="modal-body").clearfix
      .col-lg-6.col-xs-12.form-horizontal.clear_right.clearfix
        .form-group
          label.col-md-5.control-label Name
          .col-md-7.col-xs-12
            validator(name="newProfileName")
              input.form-control(v-model="editing.profile.name" maxlength='12' v-validate:newName="['deviceValid']")
              span.error(v-show='$newProfileName.newname.invalid && $newProfileName.newname.modified')
                |Please enter at least 1 English character or numbers, _ or - allowed
      .col-lg-6.col-md-6.col-sm-6.col-xs-12.form-horizontal(
        v-for="(output, input) in editing.profile.mapping"
        v-bind:class="{'clear-left': output == 0}"
        v-show="output !== 'all' ")
        .form-group
          label.input_name.col-md-5.control-label {{ output }} {{ outputCards[output].name }}
          .col-md-7
            select.form-control(v-model="input")
              option(v-for="( key , card  ) in inputCards" v-bind:value="key") {{inputCards[key].name}} (Input {{key}})
              option(value='0')
                i.fa.fa-times
                |Mute
    .modal-footer(slot="modal-footer")
      button.btn.btn-default(v-on:click="showModal = false") Cancel
      button.btn.btn-success(v-on:click="applyChange") Apply

</template>

<script>
// let $ = require('jquery')
import { call } from 'src/Service'
import { modal } from 'vue-strap'
import _ from 'lodash'
import $ from 'jquery'

export default {
  components: { modal },
  data: () => {
    return {
      showModal: false,
      editing: {
        index: null,
        profile: {}
      },
      profiles: {},
      outputCards: [],
      inputCards: []
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    let inputCards = {}
    let outputCards = {}

    return call(mac, 'dxGetPortInfo').then(({inputs, outputs}) => {
      inputCards = inputs
      outputCards = outputs
      return call(mac, 'dxGetMaps')
    }).then(({maps}) => {
      return {
        profiles: maps,
        inputCards,
        outputCards
      }
    })
  },
  events: {
    update (mac, {type, event}) {
      if (type === 'maps') {
        _.assignIn(this.profiles, event)
      }
    }
  },
  methods: {
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    toSwitchModal (key) {
      this.showModal = true
      this.editing.index = key
      this.editing.profile = _.cloneDeep(this.profiles[key])
    },
    cancel (profile) {
      this.showModal = false
      this.editing.index = null
    },
    applyChange () {
      console.log('applyChange')
      if (this.$newProfileName.newname.valid && this.editing.profile.name) {
        call(this.$route.params.mac, 'dxSetMaps', {
          maps: {
            [this.editing.index]: this.editing.profile
          }
        }).then(() => {
          this.profiles[this.editing.index] = this.editing.profile
          this.alert('success', 'Modified', 'Profiles ' + this.editing.index + ' modified.')
          this.showModal = false
        }, (rejected) => {
          this.alert('danger', 'Error', rejected)
        })
      } else {
        this.alert('danger', '', 'Please enter at least 1 English character and number only.')
      }
    }
  },
  watch: {
    showModal (nv) {
      if (!nv) {
        $('.popout').scrollTop(0)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';

  section,header{
    border-bottom:1px solid $section_border_bottom_color;
    &:last-child{
      border:none;
    }
  }
  .profile_table{
    text-align:center;
    white-space:nowrap;
    .edit{
      padding: 0;
      text-align:center;
      cursor:pointer;
      & span{
        width: 100%;
        height: 100%;
        display:block;
      }
      & i{
        line-height:32px;
        font-size: 16px;
      }
    }
    th{
      text-align:center;
    }
    .function{
      padding:0px 20px;
    }
    .profile__row{
      th:nth-child(1){
        padding:8px 10px;
      }
      color: $GLOBAL_sub_fg;
      .name{
        font-size: 10px;
      }
    }
  }
  .fa-times{
    color:#f00;
  }


  /* ==== popout modal ==== */
  .popout{
    text-align:left;
    cursor:initial;
    .input__single{
      padding:$space_xs;
      label{
        width: 30%;
      }
      .form-control{
        display:inline-block;
        width: 70%;
      }
    }

    .modal-header{
      padding:0px 15px;
      h2{
        text-transform:capitalize;
      }
      .close{
        margin-top: 8px;
      }
    }
    .modal-body {
      color:#a4a4a4;
      label{
        font-weight: 500;
        text-align: left;
      }
      & > div:nth-child(2){
        clear:left;
      }
      & > div{
        margin-bottom:5px;
      }
    }
    .input_name{
      text-transform:capitalize;
    }
    .profile_name{
      padding-left:0;
    }
  }
</style>



// WEBPACK FOOTER //
// Memory.vue?05a36272